module.exports = __webpack_public_path__ + "img/sparklers.8c1f5502.gif";